export enum TodoPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL'
}

export interface TodoItem {
  id: number;
  title: string;
  description?: string;
  isCompleted: boolean;
  isNotApplicable?: boolean; // "Niet van toepassing" status
  priority: TodoPriority;
  assignedTo?: string; // Clerk user ID

  // Generic entity fields
  entityType?: string; // e.g., 'bug-report', 'renovation-project'
  entityId?: number;

  // Legacy field for backward compatibility
  bugReportId?: number;

  order: number;
  createdAt: string;
  updatedAt: string;
}
